module.exports = __webpack_public_path__ + "static/much-better-it-e316e017f40ceb16ebf74ab333ddfae6.svg";